import React from 'react'
import { connect } from 'react-redux'
import { StaticQuery, graphql } from 'gatsby'
import { Container, Row, Col, Button } from 'reactstrap'

import * as actions from '../../state/actions/emergency'
import {getEmergency} from '../../state/reducers/emergency'

import megaphone from '../../img/icons/megaphone.svg'

const Emergency = ({emergency, closeEmergency}) => {
  // Gestion des événements clavier
  const handleKeyDown = (event, wordpressId) => {
    if (event.key === 'Escape' || event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      closeEmergency(wordpressId)
    }
  }

  return (
    <StaticQuery
      query={graphql`
        query {
          emergencies: allWordpressWpEmergency{
            edges{
              node{
                wordpress_id
                title
                emergency_link{
                  url
                  title
                  target
                }
              }
            }
          }
        }
      `}
      render={({emergencies}) => {
        if (!emergencies.edges || emergencies.edges.length === 0) {
          return null
        }

        const {wordpress_id, emergency_link, title} = emergencies.edges[0].node

        // Vérifier si l'alerte doit être affichée
        if (!emergency || !Array.isArray(emergency) || emergency.includes(wordpress_id)) {
          return null
        }

        return (
          <div 
            className="emergency py-2"
            role="alert"
            aria-live="assertive"
            aria-labelledby="emergency-title"
          >
            <Container>
              <Row>
                <Col className="d-flex align-items-center">
                  <img 
                    className="flex-shrink-0 flex-grow-0 mr-3" 
                    src={megaphone} 
                    alt="Icône d'alerte d'urgence"
                    aria-hidden="true"
                  />
                  <div>
                    <span id="emergency-title" className="emergency-title">
                      {title}
                    </span>
                    {emergency_link && (
                      <a
                        className="text-primary ml-2"
                        href={emergency_link.url}
                        target={emergency_link.target || '_self'}
                        title={emergency_link.title ? `${emergency_link.title} - ${title}` : `En savoir plus sur l'alerte : ${title}`}
                        rel={emergency_link.target === '_blank' ? "noopener noreferrer" : ""}
                        aria-label={emergency_link.title ? `${emergency_link.title} - ${title}` : `En savoir plus sur l'alerte : ${title}`}
                      >
                        {emergency_link.title || `En savoir plus sur l'alerte : ${title}`}
                      </a>
                    )}
                  </div>
                </Col>
                <Col className="flex-shrink-0 flex-grow-0 align-self-center">
                  <Button 
                    close 
                    onClick={() => closeEmergency(wordpress_id)}
                    onKeyDown={(e) => handleKeyDown(e, wordpress_id)}
                    aria-label={`Fermer l'alerte d'urgence : ${title}`}
                    title="Fermer l'alerte"
                  >
                    <span aria-hidden="true">×</span>
                  </Button>
                </Col>
              </Row>
            </Container>
          </div>
        )
      }}
    />
  )
}

  

const mapStateToProps = state => ({
  emergency: getEmergency(state)
})

export default connect(mapStateToProps, actions)(Emergency)
